import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import { EmployeeListItemFragmentDoc } from '../../../fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetTraineesWithoutHrisEmployeeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTraineesWithoutHrisEmployeeQuery = { __typename?: 'Query', Employees: { __typename?: 'Employees', totalCount: number, objects: Array<{ __typename?: 'Employee', id: number, createdAt: string, name: string, firstName: string, lastName: string, email?: string | null, phoneNumber?: string | null, language: Language, hasUsedApp: boolean, deactivatedAt?: string | null, deactivatedReason?: Types.DeactivationReason | null, userType: Types.UserType, lastActivityAt?: string | null, locations: Array<{ __typename?: 'Location', id: number, name: string }>, locationsFromDirectMemberships: Array<{ __typename?: 'Location', id: number, name: string }>, locationGroups: Array<{ __typename?: 'LocationGroup', id: string, name: string, type: Types.LocationGroupType }>, roles: Array<{ __typename?: 'Role', id: number, name: string }>, deactivatedBy?: { __typename?: 'Employee', id: number, name: string } | null, hrisEmployee?: { __typename?: 'HrisEmployee', id: number, remoteHrisId: string, firstName: string, lastName: string, startDate?: string | null } | null, notificationPreferences?: { __typename?: 'NotificationPreferences', notificationsEnabled: boolean } | null, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null }> } };

export type LinkHrisEmployeeToOpusUserMutationVariables = Types.Exact<{
  traineeId: Types.Scalars['Int']['input'];
  hrisEmployeeId: Types.Scalars['Int']['input'];
}>;


export type LinkHrisEmployeeToOpusUserMutation = { __typename?: 'Mutation', createHrisEmployeeLink: { __typename?: 'EmployeeMutationResult', success: boolean } };


export const GetTraineesWithoutHrisEmployeeDocument = gql`
    query GetTraineesWithoutHrisEmployee {
  Employees: AdminEmployees {
    totalCount
    objects {
      ...EmployeeListItem
    }
  }
}
    ${EmployeeListItemFragmentDoc}`;

/**
 * __useGetTraineesWithoutHrisEmployeeQuery__
 *
 * To run a query within a React component, call `useGetTraineesWithoutHrisEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTraineesWithoutHrisEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTraineesWithoutHrisEmployeeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTraineesWithoutHrisEmployeeQuery(baseOptions?: Apollo.QueryHookOptions<GetTraineesWithoutHrisEmployeeQuery, GetTraineesWithoutHrisEmployeeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTraineesWithoutHrisEmployeeQuery, GetTraineesWithoutHrisEmployeeQueryVariables>(GetTraineesWithoutHrisEmployeeDocument, options);
      }
export function useGetTraineesWithoutHrisEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTraineesWithoutHrisEmployeeQuery, GetTraineesWithoutHrisEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTraineesWithoutHrisEmployeeQuery, GetTraineesWithoutHrisEmployeeQueryVariables>(GetTraineesWithoutHrisEmployeeDocument, options);
        }
export type GetTraineesWithoutHrisEmployeeQueryHookResult = ReturnType<typeof useGetTraineesWithoutHrisEmployeeQuery>;
export type GetTraineesWithoutHrisEmployeeLazyQueryHookResult = ReturnType<typeof useGetTraineesWithoutHrisEmployeeLazyQuery>;
export type GetTraineesWithoutHrisEmployeeQueryResult = Apollo.QueryResult<GetTraineesWithoutHrisEmployeeQuery, GetTraineesWithoutHrisEmployeeQueryVariables>;
export const LinkHrisEmployeeToOpusUserDocument = gql`
    mutation LinkHrisEmployeeToOpusUser($traineeId: Int!, $hrisEmployeeId: Int!) {
  createHrisEmployeeLink(traineeId: $traineeId, hrisEmployeeId: $hrisEmployeeId) {
    success
  }
}
    `;
export type LinkHrisEmployeeToOpusUserMutationFn = Apollo.MutationFunction<LinkHrisEmployeeToOpusUserMutation, LinkHrisEmployeeToOpusUserMutationVariables>;

/**
 * __useLinkHrisEmployeeToOpusUserMutation__
 *
 * To run a mutation, you first call `useLinkHrisEmployeeToOpusUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkHrisEmployeeToOpusUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkHrisEmployeeToOpusUserMutation, { data, loading, error }] = useLinkHrisEmployeeToOpusUserMutation({
 *   variables: {
 *      traineeId: // value for 'traineeId'
 *      hrisEmployeeId: // value for 'hrisEmployeeId'
 *   },
 * });
 */
export function useLinkHrisEmployeeToOpusUserMutation(baseOptions?: Apollo.MutationHookOptions<LinkHrisEmployeeToOpusUserMutation, LinkHrisEmployeeToOpusUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkHrisEmployeeToOpusUserMutation, LinkHrisEmployeeToOpusUserMutationVariables>(LinkHrisEmployeeToOpusUserDocument, options);
      }
export type LinkHrisEmployeeToOpusUserMutationHookResult = ReturnType<typeof useLinkHrisEmployeeToOpusUserMutation>;
export type LinkHrisEmployeeToOpusUserMutationResult = Apollo.MutationResult<LinkHrisEmployeeToOpusUserMutation>;
export type LinkHrisEmployeeToOpusUserMutationOptions = Apollo.BaseMutationOptions<LinkHrisEmployeeToOpusUserMutation, LinkHrisEmployeeToOpusUserMutationVariables>;